import axios from "axios";

export const apiUpdate = axios.create({
  baseURL: "https://inoveupdate.inoveclube.com/api",
});
